export default __webpack_public_path__ + "static/media/07.a5e0a427.jpg";